<template>
    <section id="depoimentos">
        <div class="container">
            <h1>DEPOIMENTOS</h1>
        </div>
            <div class="arrowreference">
            <div class="arrows">
                    <a href="javascript:void(0);" class="prev" @click="showPrev">
                        <arrowslideleft/>
                    </a>
                    <a href="javascript:void(0);" class="prox" @click="showNext">
                        <arrowslideright/>
                    </a>
            </div>
            <VueSlickCarousel  v-bind="settings" class="slick-depoimentos" ref="carousel">
                    <div v-for="depoimento in depoimentos" :key="depoimento.id" class="item">
                        <!-- <div class="image"> -->
                            <!-- <img :src="depoimento.foto" :alt="depoimento.nome"> -->
                        <!-- </div> -->
                       <div class="nome">
                           {{depoimento.nome}}
                       </div>
                       <div class="funcao">
                           {{depoimento.funcao}}
                       </div>
                        <p>
                            {{depoimento.texto}}
                        </p>
                    </div>
            </VueSlickCarousel>
            
        </div>
        
    </section>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import arrowslideleft from './icones/arrowslideleft'
import arrowslideright from './icones/arrowslideright'
export default {
    name: 'Depoimentps',
    components: { VueSlickCarousel,arrowslideleft,arrowslideright },
    data(){
        return {
            depoimentos:[
                {
                    id:1,
                    nome:'Helio Mitica',
                    funcao:'Area Urbanismo',
                    foto:'',
                    texto:`
                    É um prazer trabalhar com quem se dedica com 
                    afinco a todas as etapas de desenvolvimento de projetos. 
                    A Maralto eleva Rio Grande a um novo patamar de qualidade, 
                    que com certeza será referência no mercado imobiliário.
                    `
                },
                {
                    id:2,
                    nome:'Rafael Granthan',
                    funcao:'Grantham Arquitetura',
                    foto:'',
                    texto:`
                    Desenvolver um produto com a Maralto foi um processo 
                    extremamente enriquecedor. Ficamos surpreendidos pela 
                    preocupação com a criação de experiências a serem oferecidas 
                    nos espaços propostos e com o nível de detalhe e qualidade técnica.
                    `
                },
                {
                    id:3,
                    nome:'Juliana Dorini',
                    funcao:'SCA Di Mobili',
                    foto:'',
                    texto:`
                    Ficamos encantados com a magnitude do projeto e a 
                    preocupação da Maralto em buscar parcerias locais. 
                    Percebemos que nossas empresas têm objetivos em comum, 
                    proporcionar novos espaços, projetados e desenvolvidos 
                    para melhorar a qualidade de vida das pessoas.
                    `
                },
                {
                    id:4,
                    nome:'Rafaela Valente',
                    funcao:'Urbanoria Marketing Imobiliário',
                    foto:'',
                    texto:`A parceria com a Maralto foi uma experiência 
                    incrível. Adoramos nos envolver com projetos pensados 
                    nos mínimos detalhes, com aquele cuidado 
                    especial com o cliente final.`
                },
                {
                    id:5,
                    nome:'Stela Nesello',
                    funcao:' Incomum Comunicação Estratégica',
                    foto:'',
                    texto:`
                    Trabalhar com clientes que oferecem produtos além do esperado 
                    é um dos fatores que fazem a Incomum aceitar um desafio. 
                    A Maralto está revolucionando Rio Grande e ajudará a 
                    redefinir as iniciativas da construção civil na cidade.
                    `
                }
            ],
            settings: {
                arrows: true,
                dots: false,
                autoplay:true,
                autoplaySpeed:10000,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                pauseOnHover: true,
                draggable:false,
                responsive: [
                    {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        }
                    },
                    {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        }
                    },
                    {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        }
                    }
                ] 
                   
            },
        }
    },
    methods: {
      showNext() {
        this.$refs.carousel.next()
      },
      showPrev() {
        this.$refs.carousel.prev()
      },
    },
    
}
</script>
<style lang="scss" scoped>
    @import 'node_modules/bootstrap/scss/bootstrap';
    @import 'node_modules/bootstrap-vue/src/index.scss';
    @import "../../public/variables.scss";
    section{
        background-color:$bg-gray ;
        padding-bottom: 250px;
        h1{
                font-family: 'Intro';
                font-size: 40px;
                color:$azul-escuro;
                position: relative;
                z-index: 1;
                margin-bottom: 100px;
                &::before{
                    display: block;
                    content: '';
                    position: absolute;
                    bottom: -20px;
                    left: 0;
                    width:50px;
                    height: 3px;
                    background-color: $azul-escuro;
                }
        }
        .arrowreference{
            position: relative;
            max-width: 1600px;
            margin: 0 auto;
            .arrows{
                // display: none;
                position: absolute;
                bottom:-100px;
                left: 50%;
                transform: translate(-50%);
                margin: 0 auto;
                .prev{
                    margin-right: 10px;
                }
                .prox{
                    margin-left: 10px;
                }
            }
            .slick-depoimentos{
                .item{
                    padding: 0 15px;
                    .image{
                        width: 200px;
                        height: 200px;
                        margin: 0 auto;
                        border-radius: 100%;
                        background-color:$azul-escuro;
                    }
                    .nome{
                        margin-top: 35px;
                        text-align: center;
                        text-transform: uppercase;
                        font-size: 20px;
                        color:$azul-marinho;
                    }
                    .funcao{
                        margin-bottom: 35px;
                        text-align: center;
                        text-transform: uppercase;
                        font-size: 18px;
                        color:$azul-marinho;
                    }
                    p{
                        font-size: 18px;
                        color:$font-p;
                    }
                }
            }
        }
    }
    @media(max-width:1500px){
        section{
            .arrowreference{
                max-width: 1200px;
            }
        }
    }
     @media(max-width:1200px){
        section{
            .arrowreference{
                .arrows{
                    display: block;
                }
            }
        }
    }
    @media(max-width:600px){
        section{
            padding-bottom: 180px;
                h1{
                font-size: 36px;
            }
        }
    }
</style>